import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function RefundPage() {
  return (
    <>
      <h1>Refund Policy</h1>
      <p>
        <strong>Last updated:</strong> July 26, 2026
      </p>

      <p>
        This Refund Policy applies to subscriptions purchased through
        BrickGestor, operated by <strong>Gatito Pirata Technologies EIRL</strong>,
        RUC 20616175221, Peru.
      </p>

      <h2>1. Nature of the service</h2>
      <p>
        BrickGestor is a digital Software as a Service (SaaS) platform that
        provides immediate access to online tools for managing LEGO
        inventory, pricing, and sales.
      </p>
      <p>
        As a digital service delivered electronically, BrickGestor does not
        involve the delivery of physical goods.
      </p>

      <h2>2. Right to information and transparency</h2>
      <p>Before subscribing, users are clearly informed about:</p>
      <ul>
        <li>Pricing and billing frequency</li>
        <li>Features included in each plan</li>
        <li>Whether a free trial is available</li>
        <li>Cancellation and refund conditions</li>
      </ul>
      <p>
        By completing a subscription, the user confirms that they have
        reviewed and accepted these conditions.
      </p>

      <h2>3. Refunds for first-time subscriptions</h2>
      <p>
        Peruvian consumer protection law does not require a general
        unconditional withdrawal period for digital services. As a
        goodwill measure, and in addition to any rights you may have under
        applicable consumer protection law, BrickGestor voluntarily offers
        first-time subscribers a full refund if requested within 14 days of
        the initial payment.
      </p>
      <p>
        To request this refund, contact us before the 14-day period expires,
        as described in Section 5 below.
      </p>

      <h2>4. Service failures and legal exceptions</h2>
      <p>
        In accordance with the Código de Protección y Defensa del Consumidor
        (Law N.° 29571), users may be entitled to corrective measures
        (including refunds or credits) if:
      </p>
      <ul>
        <li>The service is not provided as advertised</li>
        <li>
          There is a prolonged or recurrent technical failure attributable to
          BrickGestor
        </li>
        <li>The user is charged incorrectly</li>
      </ul>
      <p>
        Each case will be evaluated individually to determine the appropriate
        solution.
      </p>

      <h2>5. How to request a refund</h2>
      <p>Refund requests must be sent to:</p>
      <p>
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
      </p>
      <p>Please include:</p>
      <ul>
        <li>Account email address</li>
        <li>Subscription plan</li>
        <li>Description of the issue or reason for the request</li>
      </ul>
      <p>We respond to refund requests within 3–5 business days.</p>

      <h2>6. Refund processing</h2>
      <ul>
        <li>Approved refunds are issued using the original payment method.</li>
        <li>
          Processing times depend on the payment provider and may take 5–10
          business days.
        </li>
        <li>
          Transaction or processing fees charged by third parties may be
          excluded, where legally permitted.
        </li>
      </ul>

      <h2>7. Cancellation policy</h2>
      <p>
        Users may cancel their subscription at any time from their account
        dashboard.
      </p>
      <ul>
        <li>Cancellation prevents future charges</li>
        <li>Cancellation does not automatically imply a refund</li>
        <li>
          Access remains active until the end of the paid billing period,
          unless a refund is approved
        </li>
      </ul>

      <h2>8. Policy updates</h2>
      <p>
        BrickGestor may update this Refund Policy to reflect changes in
        legislation or business practices. All updates will be published on
        this page with the corresponding revision date.
      </p>

      <h2>9. Contact and consumer support</h2>
      <p>
        If you have questions, complaints, or refund requests, you may
        contact us at:
      </p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        Email:{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
      </p>
    </>
  );
}

RefundPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default RefundPage;
